import { NotificationsUpdate } from "../services/NotificationService";
import AppManager from "./AppManager";
// import PlanManager from "./PlanManager";
// import AddOnManager from "./AddOnManager";
// import IntercomManager from "./IntercomManager";

export const PAGE_ROUTES = {
  DASHBOARD: "/",
  CONTACTS: "/contacts",
  LIST: "/list",
  JOB_OPENING: "/Job-opening",
  DEALS: "/deals",
  DEAL_DETAILS: "/deal-details/:id",
  FUNNEL: "/funnel",
  FUNNEL_SELECTION: "/funnel-selection",
  FUNNEL_BUILDER: "/funnel-builder",
  FUNNEL_DOMAIN: "/funnel-domain",
  AUTOMATION: "/automation",
  AUTOMATION_BUILDER: "/automation-builder",
  AUTOMATION_REPORT: "/automation-report",
  CAMPAIGN: "/campaign",
  CAMPAIGN_BUILDER: "/campaign-builder",
  CREATE_CAMPAIGN: "/create-campaign",
  SELECT_CAMPAIGN_TEMPLATE: "/select-campaign-template",
  CAMPAIGN_SUMMARY: "/campaign-summary",
  CAMPAIGN_SUCCESS: "/campaign-success",
  FORMS: "/forms",
  SELECT_FORM_TEMPLATE: "/select-form-template",
  FORM_BUILDER: "/form-builder",
  FORM_DOMAIN: "/form-domain",
  LANDING_PAGE: "/landing-pages",
  SELECT_LANDING_PAGE_TEMPLATE: "/select-email-template",
  LANDING_PAGE_BUILDER: "/email-template-builder",
  LANDING_PAGE_DOMAIN: "/email-template-domain",
  SUPPORT: "/support",
  PUBLIC_PAGE: "/public/:id",
  PUBLIC_PAGE_PATH: "/public/",
  SETTINGS: "/settings",
  DEALS_UI: "/deal/:id",
  IMPORT_PORTAL: "/import-portal",
  CANDIDATE: "/candidate",
  CANDIDATE_UI: "/candidate/:id",
  JOB_PIPELINE: "/job-pipeline",
  JOB_FORMS: "/job-forms",
  PAYROLL_GRID: "/payrolls",
  MY_ATTENDANCE: "/my-attendance",
  TEAM_ATTENDANCE: "/team-attendance",
  PROCESS_PAYROLL: "/process-payroll/",
  PROCESS_SUMMARY: "/process-summary",
  PAYROLL_SETUP: "/payroll-setup",
  PAY_SCHEDULE_LIST: "/pay-schedule",
  CASH_FREE: "/cashFree",
  COMPONENT: "/component",
  BENEFITS: "/benefits",
  US_TAX: "/us/tax-details",
  EMPLOYEE_LIST: "/employee",
  INVESTMENTS: "/investments",
  EMPLOYEE_DETAILS: "/employee-details/",
  TERMINATE_EMPLOYEE: "/terminate-employee/",
  CUSTOM_FIELDS: "/custom-fields",
  INTEGRATION_SETTINGS: "/integration-settings",
  COMPONENT_GROUPS: "/component-groups",
  IN_TAX_DETAILS: "/in/tax-details",
  COMPANY_DETAILS: "/company-details",
  REPORTS_LIST: "/reports/report-list",
  EMPLOYEE_VIEW: "/employee-view",
  CONTRACTOR_VIEW: "/contractor-view",
  PAYSTUB_LIST: "/paystub-list",
  REPORT: {
    US: {
      PAYROLL_SUMMARY: "/reports/us/payroll-summary-report",
      W4_FORM: "/reports/us/w4-form-employees",
      W2_FORM: "/reports/us/w2-form",
      W3_FORM: "/reports/us/w3-form",
      W9_FORM: "/reports/us/w9-form-contractors",
      MISC1099: "/reports/us/1099-misc",
      NEC1099: "/reports/us/1099-nec",
      FORM941: "/reports/us/form941",
      FORM944: "/reports/us/form944",
      I9: "/reports/us/i-9",
      FORM_VT_WHT_434: "/reports/us/form-434",
      FORM_VT_WHT_436: "/reports/us/form-436",
      FORM_VT_C_101_C_107: "/reports/us/form-c101-c147",
      FORM: "/reports/us/form",
    },
    SG: {
      PAYROLL_SUMMARY: "/reports/sg/payroll-summary-report",
      CPF_SUBMISSION: "/reports/sg/cpf-e-submission",
      IRAS_SUMMARY_REPORT: "/reports/sg/iras-summary-report",
      IR8A_REPORT: "/reports/sg/ir8a-report",
      IR8S_REPORT: "/reports/sg/ir8s-report",
      APPENDIX_8A: "/reports/sg/appendix-8a",
      APPENDIX_8B: "/reports/sg/appendix-8b",
      IRAS_E_SUBMISSION: "/reports/sg/iras-e-submission",
      IRAS_AIS_SUBMISSION: "/reports/sg/iras-ais-submission",
      FORM: "/reports/sg/report",
      IRAS_SETTINGS: "/settings/iras-details",
      IRAS_CALL_BACK: "/reports/proxy/ais-submission",
      
    },
    IN: {
      PAYROLL_LIABILITY: "/reports/in/payroll-liability-report",
      FORM16:"/reports/statutory/form16"
    },
    AUTOMATION: {
        WORKFLOW: "/reports/automation/workflow",
        COMMISSION: "/reports/automation/commission"
    },
    STATUTORY_REPORTS: {
      PROFESSIONAL_TAX: "/reports/statutory/profession-tax",
      WAGE_REGISTER: "/reports/statutory/wage-register",
    },
    CUSTOM: {
      CUSTOM_REPORT: "/reports/custom-report",
    },
    MY:{
      CP39: '/reports/my/cp39',
      SOCSOBorang8A: '/reports/my/SOCSOBorang8A',
      KWSPBorangA: '/reports/my/KWSPBorangA',
      SIP: '/reports/my/SIP',
      CP8D: '/reports/my/CP8D',
      EAForm: '/reports/my/EAForm',
    }
  },
  CONTRACTOR_LIST: "/employees/contractor-list",
  CONTRACTOR_DETAILS: "/contractor-details",
  IMPORT_EMPLOYEE: "/employee-portal",
  CONTRACTOR_PAYRUN_LIST: "/employees/contractor-payrun-list",
  IMPORT_LOG: "/import-log",
  PAYSLIP_DESIGN: "/payslip-design",
  CONTRACTOR_SETTING:"/",
  EXPENSE: {
    EXPENSE_INTEGARTION_SETTINGS: "/expense/integration-settings",
    EXPENSE_CLAIM: "/expense-claims",
    EXPENSE_ADMIN_SETTING: "/expense-admin-setting",
    EXPENSE_GROUP_USER: "/expense-group-user"
  },
  MANAGE_LOCATION: "/manage-location",
  NOTIFICATION_SETTING: "/notification-setting",
  CHECK_COMPONENT_HOLDER: "/check_component",
  ATTENDANCE_SETTING: "/attendance-setting",
  IMPORT_ATTENDANCE: "/attendance-portal",
  SEQUENCE_FORMAT: "/sequence",
  APPRAISAL_CYCLE: "/appraisal-cycle",
  APPRAISAL_CYCLE_LIST: "/appraisal-cycle-list",
  APPRAISAL_CYCLE_STEP: "/appraisal-cycle-step",
  SELF_ASSESSMENT: "/self-assessment",
  ASSESSMENT_REVIEW: "/assessment-review",
  ADMIN_REVIEW: "/admin-review",
  ADD_CPF_ACCOUNT: "/add-cpf-account",
  ADD_EPF_ACCOUNT: "/add-epf-account",
  GIRO: '/giro',
  GIRO_MAKE_PAYMENT: '/giro/make-payment',
  BANK_ACCOUNTS: "/bank-accounts",
  PAYMENT_LOGS: "/payment-logs",
  MY_TAX_DETAILS: "/my/tax-details",
  BANK_ACCOUNTS: "/bank-accounts",
  NOTIFICATIONS: "/notifications",
  SHIFTS: "/shifts",
  ADD_SHIFT: "/add-shift",
  SHIFT_MEMBERS: "/shift-members",
  ASSIGN_MEMBERS: "/assign-members",
  MY_USER_TAX_DETAILS: "/my/user-tax-details",
  OVERTIME_LIST:"/overtime/list",
  OVERTIME_SETTING: "/overtime/setting",
  OVERTIME_SUMMARY: "/overtime/summary",
  OVERTIME_RATE_CONFIG: "/overtime/rate-configuration",
  FILLING_AUTHORIZATION: "/filling_authorization",
  SIGN_FORM: "/sign_form",
  COMP_OFF: {
    CONFIGURE_COMP_OFF: "/compoff/configure-comp-off",
    MANAGE_COMP_OFF: "/compoff/manage-comp-off",
    MANAGE_REQUEST: "/compoff/manage-comp-off-request",
    MY_COMP_OFF: "/compoff/my-comp-off"
  },
  EMAIL_TEMPLATE: {
    LIST: "/email-template/list"
  },
  AUDIT_LOGS: "/audit-logs",
  US_ON_BOARD: "/us_on_board",
  BIOMETRIC_ATTENDANCE_SETUP: "/biometric-attendance-settings",
  CHECKHQ_PAYROLLS: "/payrun/payrolls",
  CHECKHQ_PAYROLL_SUMMARY: "/payrun/payrolls/summary",
  IMPORT_COMPONENT_VALUES: "/import-component-values",
  PROJECTS: "/timesheet/projects",
  TASKS: "/timesheet/tasks",
  EMPLOYEE_MAPPING: "/timesheet/employee-mapping",
  TIMESHEET_ENTRY: "/timesheet/entry",
  TIMESHEET_REPORT_LIST: "/timesheet/report",
  TIMESHEET_REPORT: "/timesheet/report/timesheet-report",
  TIMESHEET_REPORT_GROUP: "/timesheet/report/timesheet-report-group",
  TIMESHEET_REPORT_CALENDAR: "/timesheet/report/timesheet-report-calendar",
  PERFORMANCE: {
    GOAL: "/performance/goal"
  },
  POLICY_AND_RESOURCES: {
    LIST: "/policy-and-resources"
  }
};
export default class RouteManager {
  static presenter = null;
  static setPresenter(presenter) {
    this.presenter = presenter;
    NotificationsUpdate.sendMessage('Route change');
    // IntercomManager.trackEvent("page", { url: window.location.pathname });
  }
  static navigateToPage(pageRoute, param = null) {
    RouteManager.presenter.props.history?.push(
      pageRoute + (param ? "?" + param : "")
    );
    AppManager.scrollToTop();
    // IntercomManager.trackEvent("page", { url: window.location.pathname });
  }

  static navigateToHome() {
    RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
  }

  static goBack() {
    RouteManager.presenter?.props?.history?.goBack()
  }

  static goForward() {
    RouteManager.presenter?.props?.history?.goForward()
  }

  // static gotoCheckout(
  //   product = null,
  //   plan = null,
  //   interval = null,
  //   addons = null
  // ) {
  //   let para_product = product ? product : PlanManager.getDefaultProduct();
  //   let para_plan = plan ? plan : PlanManager.getDefaultPlan();
  //   let para_interval = interval ? interval : PlanManager.getDefaultInterval();

  //   AddOnManager.setAddOns(addons);

  //   let url_para =
  //     "product=" +
  //     para_product +
  //     "&plan=" +
  //     para_plan +
  //     "&interval=" +
  //     para_interval;
  //   RouteManager.navigateToPage(PAGE_ROUTES.CHECKOUT, url_para);
  // }
}
